import { render, staticRenderFns } from "./DashboardActivePlan.vue?vue&type=template&id=03c6cb7a&scoped=true&"
import script from "./DashboardActivePlan.vue?vue&type=script&lang=js&"
export * from "./DashboardActivePlan.vue?vue&type=script&lang=js&"
import style0 from "./DashboardActivePlan.vue?vue&type=style&index=0&id=03c6cb7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c6cb7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
